import React from "react";
import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import Styles from "./index.module.scss";

import { Typography } from "@material-ui/core";

import { convertNumberToPersian } from "../../../method/convertDigitToEnglish";

let useStyles = makeStyles((theme) => ({
  tableParent: {
    width: "100%",
    paddingBottom: 15,
  },
  table: {
    backgroundColor: "#f2f2f2",
    width: "100%",
    "& tr": {
      "& :nth-child(odd)": {
        backgroundColor: "red",
      },
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "60%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: 0,
    outline: 0,
    padding: theme.spacing(2, 4, 3),
    position: "relative",
    paddingTop: 40,
    [theme.breakpoints.down("1000")]: {
      width: "100%",
    },
  },
}));

const Index = ({ data, loading }) => {
  const classes = useStyles();

  const columns = [
    {
      key: 1,
      id: "name",
      label: "نام شعبه",
      // minWidth: 120,
      align: "center",
    },
    {
      id: "address",
      label: "آدرس",
      // minWidth: 550,
      align: "left",
      format: (value) => convertNumberToPersian(value),
    },
    {
      id: "phoneNumber",
      label: "تلفن",
      // minWidth: 150,
      align: "center",
      format: (value) => convertNumberToPersian(value),
    },
    {
      id: "postalCode",
      label: "کد پستی",
      // minWidth: 150,
      align: "center",
      format: (value) => convertNumberToPersian(value),
    },
  ];

  let state1 = [
    {
      name: "دفتر مرکزی",
      Address: "تهران، خیابان خرمشهر ، پلاک 222، طبقه همکف واحدA",
      PostalCode: "1533743511",
      tel: "02188527379",
    },
    {
      name: "پذیرش دفتر مرکزی",
      Address: "تهران، خیابان خرمشهر، پلاک 222، طبقه همکف",
      PostalCode: "1533743511",
      tel: "02188527379",
    },
    {
      name: "شعبه فرهاد",
      Address:
        "تهران، خیابان خرمشهر، محله شهید قندی، خیابان نیلوفر، خیابان ششم، کوچه فرهاد، پلاک 8 طبقه 4 واحد 7",
      PostalCode: "1554643963",
      tel: "88756568-9",
    },
    {
      name: "شعبه شیراز ",
      Address:
        "شیراز، معالی آباد، نبش خیابان رهبرماه، مجتمع آفتاب فارس، طبقه ۳ واحد ۵۱۰",
      PostalCode: "7187783817",
      tel: "-",
    },
    {
      name: "شعبه یزد",
      Address: "اردکان، خیابان صدرآباد، جنب کوچه 69 (روبروی تاسیسات سیفی)",
      PostalCode: "8951854989",
      tel: "03532257326",
    },
    {
      name: "شعبه مشهد",
      Address:
        "مشهد، خیابان دستغیب، بین دستغیب 35 و 37، ساختمان 444، طبقه 3 واحد 8",
      PostalCode: "9185813486",
      tel: "05137055580-3",
    },
    {
      name: "شعبه اصفهان",
      Address:
        "اصفهان، خیابان باهنر، نبش کوچه شماره ۸، مجتمع مهزیار، طبقه دوم واحد ۸",
      PostalCode: "8138785861",
      tel: "03133447803",
    },
  ];

  const safeConvertNumberToPersian = (value) => {
    if (value == null || value === "") return "-";
    return convertNumberToPersian(value);
  };

  const [state, setState] = useState([]);

  useEffect(() => {
    setState(data ?? []);
  }, [data]);

  function api() {}

  return (
    <>
      <div className={`${classes.tableParent}`}>
        <table className={Styles.table} id="listingTable">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>ردیف</th>

              {columns.map((itm, ind) => (
                <th
                  style={{ minWidth: itm.minWidth, textAlign: "center" }}
                  key={ind}
                >
                  {itm.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {state.map((itm, ind) => {
              const isTehranMarkazi = itm?.name === "تهران- مرکزی";

              return (
                <tr
                  key={ind}
                  style={isTehranMarkazi ? { fontWeight: 700 } : undefined}
                >
                  <td style={{ textAlign: "center" }}>
                    {convertNumberToPersian(ind + 1)}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {safeConvertNumberToPersian(itm?.name)}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {safeConvertNumberToPersian(itm?.address)}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {itm?.phoneNumber ? (
                      <>
                        {itm?.cityCodePhoneNumber
                          ? `${safeConvertNumberToPersian(
                              itm.cityCodePhoneNumber,
                            )}-${safeConvertNumberToPersian(itm.phoneNumber)}`
                          : safeConvertNumberToPersian(itm.phoneNumber)}
                      </>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {safeConvertNumberToPersian(itm?.postalCode)}
                  </td>
                </tr>
              );
            })}

            {state?.length === 0 && (
              <tr>
                <td colSpan={4} style={{ width: "100%" }}>
                  <Typography variant="inherit" component="h5">
                    {loading
                      ? "در حال بارگذاری..."
                      : "داده ای برای نمایش وجود ندارد."}
                  </Typography>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Index;
